const report_categories = {
   "Team KPI performance": "sales",
   "Agent KPI performance": "sales",

   "Lead batch performance analysis": "lead_data",
   "Lead data supplier comparison": "lead_data"
}

export default report_categories